// Hook do pobierania listy klientow bez przypisanego handlowca (do przypisania) - GET /sales-crm/clients/assignable?search_keyword=...

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IResponse as IClientResponse } from 'api/endpoints/useGetClient';

/** Element listy klientow do przypisania (alias dla kompatybilnosci z widokiem) */
export type IAssignableClient = IClientResponse;

/** Odpowiedz API listy klientow do przypisania */
export interface IAssignableClientsResponse {
  items: IAssignableClient[];
  total_count: number;
  total_pages: number;
}

const getAssignableClients = (searchKeyword: string): Promise<IAssignableClientsResponse> =>
  axios.get('/sales-crm/clients/assignable', {
    params: { search_keyword: searchKeyword || undefined }
  });

export const useGetAssignableClients = (
  searchKeyword: string,
  options?: UseQueryOptions<IAssignableClientsResponse, IError>
) =>
  useQuery<IAssignableClientsResponse, IError>(
    ['sales-crm', 'assignable-clients', searchKeyword],
    () => getAssignableClients(searchKeyword),
    {
      ...options,
      enabled: (options?.enabled !== false) && searchKeyword.trim().length > 0
    }
  );
